<template>
    <section class="content">
        <div class="box box-info">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2" id="billNo" >
                  <label for="billNo" >Order No :</label>
                  <span class="purchaseOutput "><b>{{salesHeaderObj.orderNo}}</b></span>
              </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="salesDate" >Date :</label>
                  <span class="purchaseOutput"><b>{{salesHeaderObj.orderDate}}</b></span>
               </div>
               <div class="p-field p-col-12 p-md-2">
                    <label for="suppplier">Name :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.customerName}}</b>
                    </span>
               </div>

               <div class="p-field p-col-12 p-md-2">
                    <label for="suppplier">Contact :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.primaryContact}}</b>
                    </span>
               </div>

               <div class="p-field p-col-12 p-md-2">
                    <label for="suppplier">Secondary Contact :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.secondaryContact}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-2" >
                    <label for="suppplier">Address :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.address}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-2" >
                    <label for="suppplier">Shipping Address :</label>
                    <span class="purchaseOutput ">
                      <b>{{salesHeaderObj.shippingAddress}}</b>
                    </span>
               </div>
                <div class="p-field p-col-12 p-md-6"></div>

             </div>
               <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th>SN</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Amount</th>
                    <!-- <th>Action</th> -->
                  </tr>
                </thead>
                <tbody  v-for="(pd,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{pd.itemName}}</td>
                    <td>{{pd.quantity}}</td>
                    <td>{{pd.rate}}</td>
                    <td>{{(pd.quantity * pd.rate).toFixed(4)}} </td>
                    <!-- <td>
                      <div class="p-field p-col-12 p-md-2" v-if="checkPos">
                      <Button class="p-button-raised" @click.prevent="posDetail(pd.itemMaster.id)" icon="pi pi-eye"/>
                      </div>
                    </td> -->
                  </tr>
                </tbody>
              </table>
          <div class="p-field p-col-12 p-md-4">
            <label >Remarks</label>
            <textarea type="text" rows="6" class="form-control"  v-model="salesHeaderObj.remarks"/>
         </div>
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2" >
              <label for="subttotal">Subtotal: {{(salesHeaderObj.subTotalAmount).toFixed(4)}} </label>
            </div>
          </div> -->
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="discountAmt">Discount Amt: {{(salesHeaderObj.discountAmt).toFixed(4)}}</label>
            </div>
          </div> -->
          <!-- <label for="exciseAmt">Excise Amt</label>
          <span id="exciseAmt" style="margin-left: 2.3em;" class="_span">{{salesHeaderObj.exciseChargeAmount}}</span>
          <br/> -->
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="nontaxable">Non-taxable:{{(salesHeaderObj.nonTaxableAmount).toFixed(4)}}</label>
            </div>
          </div> -->
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="taxable">Taxable:{{(salesHeaderObj.taxableAmount).toFixed(4)}}</label>
            </div>
          </div> -->
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="tax">Tax(13%):{{(salesHeaderObj.vatAmount).toFixed(4)}}</label>
            </div>
          </div> -->
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-10"></div>
            <div class="p-field p-col-12 p-md-2">
              <label for="total">Total:{{(salesHeaderObj.billAmount).toFixed(4)}}</label>
            </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-10"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised" icon="pi pi-refresh" @click.prevent="$router.back()" label="Back"/>
          </div>
        </div>
     </div>

    </section>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
export default {
  name: 'ecommerceOrderHeader',
  props: ['salesHeaderObj'],
  data() {
    return {
      inventoryInOutDetailList: [],
      filters: {}
    }
  },
  mounted() {
    this.searchInventoryOutDetail()
  },
  methods: {
    async searchInventoryOutDetail() {
      if (this.salesHeaderObj === undefined) {
        this.$router.back()
        return
      }
      let resp = await this.$store.dispatch('loadEcommerceOrderDetail', this.salesHeaderObj.id)
      this.inventoryInOutDetailList = resp.data.data
    },
    cancel() {
      this.showPosDialog = false
    }
  },
  components: {
    Button,
    Dialog,
    DataTable,
    Column,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css" >

</style>



// WEBPACK FOOTER //
// orderDetails.vue?ded506ba